import React, { Component } from 'react'
import FixedView from '../../../FixedView'
import SwitchInput from '../../../inputs/SwitchInput'
import Members from '../sideBar/Members'
import StagesManager from '../../../StagesManager'
import SupportInfoFirst from './SupportInfoFirst'
import SidebarView from '../../../SidebarView'





export default class SupportInfo extends Component {
    state = {
        showCollapse: null,
        active: false,
        selected: 0,
        checkBox: {},
        show: false,

        Members: [
            { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "Online", role: "Owner" },
            { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "Online", role: "Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "Online", role: "Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "Online", role: "Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "Online", role: "Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "Online", role: "Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "Online", role: "Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "Online", role: "Owner" },
            // { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "Online", role: "Owner" },
        ],

        // option: [
        //     { icon: "/assets/icons/manage-gray.svg", title: "Add Admine", color: "#444", key: "manage" },
        //     { icon: "/assets/icons/leave-red.svg", title: "Leave Group", color: "#E61515", key: "leave" },
        // ],

        manage: [
            // { icon: "/assets/icons/messenger/group.svg", name: "Group Type", state: "Private", key: "grouptype" },
            // { icon: "/assets/icons/messenger/chat.svg", name: "Chat history for new members", state: "Visible", key: "chatsetting" },
            // { icon: "/assets/icons/messenger/topic.svg", name: "Topics", state: "", key: "topic" },
            // { icon: "/assets/icons/messenger/like.svg", name: "Reaction", state: "All", key:"grouptype" },
            { icon: "/assets/icons/messenger/key.svg", name: "Permissions", state: "8/8", key: "permission" },
            // { icon: "/assets/icons/messenger/link.svg", name: "Invite links", state: "1", key:"grouptype" },
            { icon: "/assets/icons/messenger/shield.svg", name: "Adminestators", state: "1", key: "adminestators" },
            { icon: "/assets/icons/messenger/statistic.svg", name: "Statistics", state: "4", key: "statistics" },
            { icon: "/assets/icons/messenger/setting.svg", name: "Setting", state: "4", key: "setting" },
            // { icon: "/assets/icons/messenger/bolt.svg", name: "Recent actions", state: "", key:"grouptype" },
        ]
    }


    componentDidMount() {
        // console.log('pvkss', this.props.messenger)

        this.sidebarView.openSidebar()
        let supportInfo = {}
        this.props.messenger?.users.forEach(user => {
            // console.log('user mess', user)
            if (this.props.myId != user.hub._id) {
                // console.log('supportInfo', user)
                // console.log(this.props.myId)
                supportInfo.username = user.hub?.username
                supportInfo.fullname = user.hub?.fullname
                supportInfo.phone = user.hub?.phone
                supportInfo.image = user.hub?.image
                supportInfo.status = this.props.messenger.status
                supportInfo.assignee = this.props.messenger?.assignee

            }
        });
        this.setState({ supportInfo })
    }
    openSidebar = () => {
        this.sidebarView.openSidebar()
    }

    openFirstView = () => {
        this.firstView.showView()
    }

    openMemberView = () => {
        this.memberView.showView()
    }




    render() {
        let type = this.state.type
        return (
            <div className='w-100 h-100'>
                <SidebarView onClosed={this.onClosed} hight={"100%"} width={this.props.width} hideOverlay={false} ref={el => this.sidebarView = el} widthCondition={{ xs: "100%", sm: "100%", md: '35%', lg: "35%", xl: "25%" }}>
                    <div className='w-100 h-100' >
                        <StagesManager ref={el => this.stageManager = el} height={"100%"} fast={true}>
                            <SupportInfoFirst language={this.props.language} media={this.state.media} supportInfo={this.state.supportInfo} width={this.props.width} height={"100%"} changeStage={this.changePage} stage={0} stageName={''} messenger={this.props.messenger} colors={this.props.colors} applet={this.props.applet} />
                        </StagesManager>
                    </div>
                </SidebarView>
            </div>
        )
    }
}
